import { useEffect } from 'react';
import { Application } from 'foundations-components/components/Application';
import EnvironmentMismatch from './alerts/EnvironmentMismatch';
import BrowserVersionWrapper from './alerts/BrowserVersionWrapper';
import I18n from 'I18n';
import { useQueryData } from '../hooks/useQueryData';
import { checkSafeOpener } from '../utils/checkSafeOpener';
import Compliance from './Compliance/Compliance';
import { useHistory } from 'react-router-dom';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { View } from 'foundations-components/transitional/components/View';
import { Header } from './Header';
import { Footer } from './Footer';
import { MarketingCta } from './MarketingCta';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LoginApplication = ({
  children,
  hideBackToLogin = false,
  inlineSize = '460px',
  showHeader = true,
  showFooter = true,
  showMarketingCta = false
}) => {
  const {
    allQueryParams
  } = useQueryData();
  const history = useHistory();
  const isMobileLogin = !!allQueryParams.reauth;
  useEffect(() => {
    document.title = I18n.text('login.title');
    checkSafeOpener({
      loginRedirectUrl: allQueryParams.loginRedirectUrl
    });
  }, [allQueryParams.loginRedirectUrl]);
  return /*#__PURE__*/_jsxs(Application, {
    name: "LoginUI",
    blockSize: "100vh",
    children: [/*#__PURE__*/_jsx(EnvironmentMismatch, {}), !isMobileLogin && /*#__PURE__*/_jsx(Compliance, {
      pathname: history.location.pathname
    }), /*#__PURE__*/_jsxs(BrowserVersionWrapper, {
      children: [showHeader && /*#__PURE__*/_jsx(Header, {
        hideBackToLogin: hideBackToLogin
      }), /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        direction: "column",
        justify: "center",
        blockSize: showHeader ? '75%' : '85%',
        children: [/*#__PURE__*/_jsx(View, {
          flexGrow: 1,
          inlineSize: inlineSize,
          minInlineSize: inlineSize,
          children: children
        }), showMarketingCta && /*#__PURE__*/_jsx(MarketingCta, {}), showFooter && /*#__PURE__*/_jsx(Footer, {})]
      })]
    })]
  });
};